import { render, staticRenderFns } from "./card-servizio.vue?vue&type=template&id=1a17ff8f&"
import script from "./card-servizio.vue?vue&type=script&lang=js&"
export * from "./card-servizio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports